var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppAnalytics = function SvgAppAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19H0v-5h6V8h6V0h7v19h-6.5zM1 15h5v3H1v-3zm6-6h5v9H7V9zm6-8h5v17h-5V1z",
    fillRule: "evenodd"
  })));
};
export default SvgAppAnalytics;